import { ButtonAction } from 'components/button/ButtonAction';
import { InputTitle } from 'components/input/InputTitle';
import CommonSelect from 'components/select/CustomSelect';
import { Row, Spacing, TextInput, Typography, neutral } from 'enable-ui';

import { AnimatedRow, GeneralContainer } from 'modules/institution-info/styles/general';

import { COLOR } from 'constants/color';

import { useGeneralController } from '../core/controllers/general';

const GeneralPage = () => {
  const {
    values,
    handleChange,
    disabled,
    handleSubmit,
    onCancel,
    isBiologicAdmin,
    handleStationsChange,
    mappingStations,
    selectedStation,
    selectedStationInfo,
  } = useGeneralController();

  return (
    <GeneralContainer>
      <Row
        direction="column"
        style={{
          paddingBottom: 48,
          borderBottom: `1px solid ${neutral['neutral-5']}`,
        }}
      >
        <Spacing spacing="md" type="margin" placement="bottom">
          <Typography weight={500} style={{ fontSize: 22, lineHeight: '30px', color: '#222222' }}>
            General
          </Typography>
        </Spacing>

        <Row direction="column" style={{ marginBottom: 16 }}>
          <InputTitle title="Institution name" />
          <TextInput name="name" onChange={handleChange} value={values.name} />
        </Row>

        {isBiologicAdmin && (
          <Row direction="column">
            <InputTitle title="Institution ID" />
            <TextInput name="code" onChange={handleChange} value={values.code} />
          </Row>
        )}
      </Row>
      <Row
        direction="column"
        style={{
          paddingBottom: 16,
          marginTop: 12,
        }}
      >
        <Spacing spacing="md" type="margin" placement="bottom">
          <Typography weight={500} style={{ fontSize: 22, lineHeight: '30px', color: '#222222' }}>
            Headquarter address
          </Typography>
        </Spacing>

        {/* <Row direction="column" style={{ marginBottom: 24 }}>
          <InputTitle title="Address / Region" />
          <TextInput name="address" onChange={handleChange} value={values?.address} />
        </Row> */}
        <Row direction="column" className="mb-16">
          <InputTitle title="Location" />
          <CommonSelect
            value={selectedStation}
            options={mappingStations}
            onChange={handleStationsChange}
            onInputChange={() => {}}
            controlStyle={{ width: '100%', background: 'white', borderRadius: 12 }}
            onFocus={() => {}}
          />
        </Row>

        {selectedStation && (
          <>
            <AnimatedRow className="mb-16">
              <article className="w-1-2">
                <InputTitle title="Country" />
                <Typography variant="body-3" color={COLOR.surfaceNeutralBold['neutral-11']}>
                  {selectedStationInfo?.country}
                </Typography>
              </article>

              <article className="w-1-2">
                <InputTitle title="State" />
                <Typography variant="body-3" color={COLOR.surfaceNeutralBold['neutral-11']}>
                  {selectedStationInfo?.state}
                </Typography>
              </article>
            </AnimatedRow>

            <AnimatedRow className="mb-16">
              <article className="w-1-2">
                <InputTitle title="City" />
                <Typography variant="body-3" color={COLOR.surfaceNeutralBold['neutral-11']}>
                  {selectedStationInfo?.city}
                </Typography>
              </article>

              <article className="w-1-2">
                <InputTitle title="Postal Code" />
                <Typography variant="body-3" color={COLOR.surfaceNeutralBold['neutral-11']}>
                  {selectedStationInfo?.postalCode}
                </Typography>
              </article>
            </AnimatedRow>

            <AnimatedRow direction="column">
              <InputTitle title="Address" />
              <Typography variant="body-3" color={COLOR.surfaceNeutralBold['neutral-11']}>
                {selectedStationInfo?.address}
              </Typography>
            </AnimatedRow>
          </>
        )}

        {/* <div style={{ width: '40%' }}>
            <Row direction="column" style={{ marginBottom: 24 }}>
              <InputTitle title="City" />
              <TextInput name="city" onChange={handleChange} value={values?.city} />
            </Row>
          </div>

          <div style={{ width: '40%' }}>
            <Row direction="column" style={{ marginBottom: 16 }}>
              <InputTitle title="Country" />
              <TextInput name="country" onChange={handleChange} value={values?.country} />
            </Row>
          </div> */}

        {/* <Row direction="column">
            <InputTitle title="Zipcode" />
            <TextInput
              name="stationId"
              onChange={handleChange}
              value={values?.stationId}
              maxLength={4}
            />
          </Row> */}
      </Row>
      <ButtonAction
        disabledCancel={disabled}
        disabledSubmit={disabled}
        onCancel={onCancel}
        onSubmit={() => handleSubmit()}
      />
    </GeneralContainer>
  );
};

export default GeneralPage;
